class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.headerSelect = this.querySelector("[data-sticky-header]");
  }

  connectedCallback() {

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);

  }

  onScroll() {
    const scrollTop = document.documentElement.scrollTop;
    if ( scrollTop > 420 ) {
        this.headerSelect.classList.add("sticky-active");

    }else{
        this.headerSelect.classList.remove("sticky-active");
    }
  }
}
customElements.define("sticky-header", StickyHeader);